import { type FC, PropsWithChildren } from 'react';

import { Wrapper } from './styled';

type Props = {
  testId?: string;
};

const FilterWrapper: PropsWithChildren<FC<Props>> = ({ children, testId = 'filterWrapper' }): JSX.Element => (
  <Wrapper data-testid={testId}>{children}</Wrapper>
);

export default FilterWrapper;
